import { useState } from "react";
import {
  TextField,
  IconButton,
  Dialog,
  Box,
  Tooltip,
  Container,
  Stack,
  Button,
  Chip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import RemoveIcon from "@mui/icons-material/Remove";

import conf from "../../conf";
import InfoChip from "./InfoChip";
import SectionHeader from "./SectionHeader";
import { useProxyKeyEditTags } from "../../hooks/proxy/keys";
import { useProxyProjectEditTags } from "../../hooks/proxy/projects";

type TagsWithEditProps = {
  id: string;
  tags: string[];
  type: "project" | "key";
  readOnly: boolean;
};
const TagsWithEdit = (props: TagsWithEditProps) => {
  const { id, type, readOnly } = props;

  const key = useProxyKeyEditTags();
  const project = useProxyProjectEditTags();

  const [tags, setTags] = useState<string[]>(props.tags);
  const [current, setCurrent] = useState<string>("");
  const [isEditing, setIsEditing] = useState(false);

  const add = () => {
    if (!!current.trim() && !tags.includes(current)) {
      const updated = [...tags, current.trim()];

      if (type === "key") {
        key.mutate({ id, tags: updated });
      } else if (type === "project") {
        project.mutate({ id, tags: updated });
      }

      setTags(updated);
      setCurrent("");
    }
  };

  const remove = (tag: string) => {
    const updated = tags.filter((cur) => cur !== tag);

    setTags(updated);

    if (type === "key") {
      key.mutate({ id, tags: updated });
    } else if (type === "project") {
      project.mutate({ id, tags: updated });
    }
  };

  const handleOpen = () => setIsEditing(true);
  const handleClose = () => {
    setCurrent("");
    setIsEditing(false);
  };

  const TagChip = (
    <InfoChip
      color="primary"
      info={tags.join(", ")}
      icon={<EditIcon fontSize="inherit" />}
    />
  );

  return (
    <>
      {/* Tags and Edit Button */}
      <Box display="flex" justifyContent="end">
        {readOnly ? (
          TagChip
        ) : (
          <IconButton onClick={handleOpen} color="inherit">
            {TagChip}
          </IconButton>
        )}
      </Box>

      {/* Edit Modal */}
      <Dialog fullWidth maxWidth="md" open={isEditing} onClose={handleClose}>
        <Container component="main" sx={conf.STYLE.DIALOG}>
          <SectionHeader
            title="Edit tags"
            icon={<EditIcon />}
            buttons={[
              <Button key="tags-close" color="inherit" onClick={handleClose}>
                <CloseIcon />
              </Button>,
            ]}
          />

          <Stack direction="row" spacing={1} m={2} flexWrap="wrap">
            {tags.map((tag) => (
              <Chip
                key={tag}
                label={tag}
                color="primary"
                onDelete={() => remove(tag)}
                deleteIcon={
                  <Tooltip title="delete">
                    <RemoveIcon />
                  </Tooltip>
                }
              />
            ))}
          </Stack>

          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            sx={{ mt: 2 }}
          >
            <TextField
              size="small"
              label="Add tag"
              variant="outlined"
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && add()}
            />

            {/* <Button variant="outlined" onClick={handleClose}>
              Cancel
            </Button> */}

            <Button variant="contained" onClick={add} disabled={!current}>
              Add
            </Button>
          </Stack>
        </Container>
      </Dialog>
    </>
  );
};

export default TagsWithEdit;
